// NO EDITAR A MANO
// const id = "footer.link_social.siguenos";
const valor = `Follow us`;

export default valor;
